import React from "react";

import { Container } from "shards-react";

const NoLayout = ({ children, disableAll, noNavbar }) => (
  <Container fluid>{children}</Container>
);

export default NoLayout;
